<template>
    <v-app>
        <v-form ref="refMain">
            <v-card flat :loading="dIsUpdating">
                <v-card-text fluid>
                    <v-row dense>
                        <v-col cols="12" xm="12">
                            <v-card>
                                <v-card-subtitle class="pb-0"><h2>* Seleccionar el tipo de comunicación</h2></v-card-subtitle>
                                <v-card-actions class="py-0">
                                    <v-radio-group row :rules="[v => !!v || 'El campo es requerido']">
                                        <v-radio label="Incidencia" value="301"></v-radio>
                                        <v-radio label="Sugerencia" value="300"></v-radio>
                                        <v-radio label="Reconocimiento" value="302"></v-radio>
                                    </v-radio-group>
                                </v-card-actions>
                                <v-card-subtitle class="pb-0"><h2>¿Eres representante de Aula?</h2></v-card-subtitle>
                                <v-card-actions class="py-0">
                                    <v-checkbox
                                        label="Si"
                                        value="0"
                                    ></v-checkbox>
                                </v-card-actions>
                                <v-card-subtitle class="pb-0"><h2>Mensaje</h2></v-card-subtitle>
                                <v-card-text>
                                    <v-col cols="12" xm="12">
                                        <v-textarea v-model="dCrmTicketComentario_mensaje" label="* Mensaje"
                                            prepend-inner-icon="message" outlined rows="2" row-height="15" :rules="[v => !!v || 'El campo es requerido']"
                                        ></v-textarea>
                                    </v-col>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click.prevent="fuSave" :loading="dIsUpdating" color="primary" ><v-icon>send</v-icon> Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-app>
</template>

<script>
import moment from 'moment';
import gql from 'graphql-tag';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'TicketAlumno',
    data: () => ({
        dIsUpdating: false,
        dLoading: false,
        dCrmTicketComentario_mensaje: '',
    }),
    methods: {
        async fuLoad(){
            console.log("hola mundo");
        },
        fuSave(){
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = true;
            } else {
                console.log("enviando ...");
                // this.fuCreate();
            }
        },
    }
}
</script>

<style>

</style>